'use strict';

var buildDateRangeUnits = require('../internal/buildDateRangeUnits');

buildDateRangeUnits();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/build/buildDateRangeUnitsCall.js
// module id = 31
// module chunks = 0